import { render } from "./letter-tag-create-import.vue?vue&type=template&id=79c17eef"
import script from "./letter-tag-create-import.vue?vue&type=script&lang=js"
export * from "./letter-tag-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__